import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const HomeIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-home"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M46,15 C46.5128358,15 46.9355072,15.3860402 46.9932723,15.8833789 L47,16 L47,32.001 C47,33.05509 46.1847739,33.9182293 45.150221,33.9945186 L45.001,34 L20.999,34 C19.94491,34 19.0817707,33.1847739 19.0054814,32.150221 L19,32.001 L19,17 C19,16.4477153 19.4477153,16 20,16 C20.5128358,16 20.9355072,16.3860402 20.9932723,16.8833789 L21,17 L21,32 L45.0003932,32.0003932 L45,16 C45,15.4477153 45.4477153,15 46,15 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="29 32 37 32 37 21 29 21"
        />
        <path
          d="M33.7384,0 C33.3074,0 32.8764,0.139 32.5154,0.417 L14.2774,14.508 C13.8474,14.841 13.5704,15.334 13.5114,15.874 C13.4534,16.415 13.6164,16.956 13.9654,17.373 L15.5234,19.239 C15.9184,19.712 16.4864,19.957 17.0604,19.957 C17.4874,19.957 17.9184,19.821 18.2814,19.54 L33.6954,7.632 L48.6654,19.564 C49.0324,19.857 49.4734,20 49.9104,20 C50.4734,20 51.0324,19.764 51.4264,19.306 L53.0154,17.463 C53.3704,17.051 53.5424,16.512 53.4914,15.971 C53.4404,15.429 53.1714,14.932 52.7464,14.593 L34.9854,0.436 C34.6204,0.146 34.1794,0 33.7384,0 L33.7384,0 Z M33.7384,2 L51.5004,16.157 L49.9114,18 L33.7144,5.09 L17.0584,17.957 L15.5004,16.091 L33.7384,2 Z"
          fill="#00000"
          className={styles.defaultColor}
        />
        <path
          d="M26,1.9998 L22,1.9998 C21.4477153,1.9998 21,2.44751525 21,2.9998 L21,9.5058 C21,10.3112111 21.9034882,10.7861798 22.5669483,10.3295534 L26.5669483,7.57655339 C26.8380592,7.38996128 27,7.08191664 27,6.7528 L27,2.9998 C27,2.44751525 26.5522847,1.9998 26,1.9998 Z M25,3.999 L25,6.227 L23,7.604 L23,3.999 L25,3.999 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
